// CompanySidebar.jsx
import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Sidebar.css";

const CompanySidebar = ({ isOpen, onItemClick }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const sidebarRef = useRef(null);
  const [activeSection, setActiveSection] = useState("");

  // List of company‐dashboard sections
  const sections = [
    { id: "assessment-dashboard", name: "Assessment Dashboard"},
    { id: "view-company", name: "View Company" },
    { id: "all-assessments", name: "Assessments by users" },
    { id: "assessment-status", name: "Assessment completion status" },
    { id: "edit-company", name: "Edit companies" },
    // { id: "subscription-status", name: "Subscription status" },
    // { id: "assign-assessments", name: "Assign assessments" },
  ];

  // Highlight based on URL
  useEffect(() => {
    const parts = location.pathname.split("/");
    const idx = parts.findIndex((p) => p === "company");
    if (idx !== -1 && parts.length > idx + 1) {
      setActiveSection(parts[idx + 1]);
    } else {
      setActiveSection("");
    }
  }, [location]);

  // Close when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        isOpen &&
        sidebarRef.current &&
        !sidebarRef.current.contains(e.target)
      ) {
        onItemClick?.();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen, onItemClick]);

  const handleSectionClick = (sectionId) => {
    setActiveSection(sectionId);
    navigate(`/company/${sectionId}`);
    onItemClick?.();
  };

  return (
    <div
      ref={sidebarRef}
      className={`sidebar ${isOpen ? "open" : ""}`}
    >
      {/* Close button */}
     {isOpen&& <div className="sidebar-close-btn" onClick={() => onItemClick?.()}>
        &times;
      </div>}

      <ul>
        {sections.map((section) => (
          <li
            key={section.id}
            className={activeSection === section.id ? "active" : ""}
            onClick={() => handleSectionClick(section.id)}
          >
            {section.name}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CompanySidebar;
